<template>
  <aliyun-player
    :preload="true"
    :autoplay="true"
    :source="sourceUrl"
    :cover="coverUrl"
    ref="video"
    class="video"
    :skinLayout="skinLayout"
    :height="videoHeight"
    :video-height="videoHeight"
    @canplaythrough="canplaythroughimp"
    @pause="pause"
    @play="play"
    @ended="ended"
  />
</template>

<script>
import AliyunPlayer from './AliyunPlayer'

export default {
  name: 'VideoPlayer',
  components: {
    AliyunPlayer
  },
  props: {
    playInfo: Object,
    videoHeight: String,
    coverUrl: String,
    // 播放状态：1-播放 0-暂停
    status: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      sourceUrl: '',
      identifier: new Date().getTime(),
      progressToSeek: 0,
      skinLayout: [
        {
          name: 'bigPlayButton',
          align: 'cc'
        },
        {
          name: 'H5Loading',
          align: 'cc'
        },
        {
          name: 'errorDisplay',
          align: 'tlabs',
          x: 0,
          y: 0
        },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            {
              name: 'progress',
              align: 'blabs',
              x: 0,
              y: 44
            },
            {
              name: 'playButton',
              align: 'tl',
              x: 15,
              y: 12
            },
            {
              name: 'timeDisplay',
              align: 'tl',
              x: 10,
              y: 7
            },
            { name: 'setting', align: 'tr', x: 15, y: 12 },
            { name: 'volume', align: 'tr', x: 5, y: 10 },
            {
              name: 'fullScreenButton',
              align: 'tr',
              x: 10,
              y: 12
            }
          ]
        }
      ]
    }
  },
  computed: {
    player() {
      return this.$refs.video
    }
  },
  watch: {
    status(value, old) {
      if (value === 1) {
        this.setPlay()
      } else if (value === 0) {
        this.setPause()
      }
    },
    playInfo(value, old) {
      if (!value) return

      console.log('playinfo->----', value, old)
      console.log(value.playURL)

      this.progressToSeek = value.progress ? value.progress : 0

      this.sourceUrl = value.playURL
      this.$refs.video.reloadPlayer()
    },
    currentVideo() {
      this.identifier = new Date().getTime()
    }
  },
  methods: {
    uploadProgress() {
      // const currentTime = this.$refs.video.getCurrentTime().toFixed(0)
      // if (currentTime === 0) return 0
      // const params = {
      //   identifier: this.identifier,
      //   videoIdentity: this.currentVideo,
      //   progress: currentTime
      // }
      // console.log(params)
      // this.requestUploadProgress(params)
    },
    setPause() {
      const player = this.$refs.video
      player && player.pause()
    },
    setPlay() {
      const player = this.$refs.video
      player && player.play()
    },
    pause() {
      this.$emit('pause')
    },
    play() {
      this.$emit('play')
    },
    ended() {
      this.$emit('ended')
    },
    canplaythroughimp() {
      const _this = this
      // setTimeout(() => {
      //
      // }, 800)
      var duration = this.$refs.video.getDuration()
      console.log('duration' + duration)
      if (_this.progressToSeek !== 0 && _this.progressToSeek < duration) {
        console.log('seek' + _this.progressToSeek)
        _this.$refs.video.seek(_this.progressToSeek)

        setTimeout(() => {
          if (_this.$refs.video.getCurrentTime() < _this.progressToSeek) {
            this.canplaythroughimp()
          } else {
            _this.progressToSeek = 0
          }
        }, 500)
      }
    }
  },

  mounted() {
    setInterval(() => {
      this.uploadProgress()
    }, 10000)
  }
}
</script>

<style scoped></style>
